<!--
 * @Author: chi.yong chi.yong@jitai.ai
 * @Date: 2024-05-10 14:39:15
 * @LastEditors: chi.yong chi.yong@jitai.ai
 * @LastEditTime: 2025-02-11 20:53:29
 * @FilePath: /JTFEE_open_api_platform/src/App.vue
 * @Description: app entry
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<script setup lang="ts">
import Loading from '@/views/components/Loading.vue';
import { isLoading } from './router'; // 从 router 导入 isLoading
const handleRouteChange = () => {
  isLoading.value = true;
};

const handleRouteEnd = () => {
  isLoading.value = false;
};

const intervalId = ref<number | null>(null);

onBeforeUnmount(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
    intervalId.value = null;
  }
});
</script>

<template>
  <Loading :isLoading="isLoading" />
  <RouterView @routeChangeStart="handleRouteChange" @routeChangeEnd="handleRouteEnd" />
</template>
